module.exports = __webpack_public_path__ + "static/img/electrode-pad.144fe101.png";